import { Component, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

interface Props {
  children: ReactNode;
  fallback?: (error: Error, reset: () => void) => ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  override render(): ReactNode {
    if (this.state.error) {
      const reset = (): void => this.setState({ error: null });
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, reset);
      }
      return (
        <div className="p-8">
          <div className="card max-w-[640px] mx-auto">
            <h2 className="font-display text-[20px] leading-7 font-semibold mb-2">
              Something went wrong
            </h2>
            <p className="text-[13px] leading-[18px] text-[var(--color-fg-muted)] mb-4">
              {this.state.error.message}
            </p>
            <button className="btn btn-secondary btn-sm" onClick={reset}>
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
